import { httpRequest } from "../../../utils/HttpRequest";
import { IPage, ISearchPage } from "@/types/ScmTypes";


//详情
export interface IVRMShopDetail {
    id: string,              // "bf9dc1a3b9647038f96e545229b25e72",
    code: string,              // "ETY-M-gSUn-00000019",
    orderNum: string,              // 0,
    deleteFlag: string,              // 0,
    createTime: string,              // ,
    updateTime: string,              //,
    createUser: string,              // "默认用户",
    updateUser: string,              // "默认用户",
    branch: string,              // "main",
    ver: string,              // 6,
    enable: string,              // null,
    orgCode: string,              // "机构编码",
    orgName: string,              // "机构名称",
    name: string,              // "站点名称",
    contact: string,              // "联系人",
    phone: string,              // "332",
    address: string,              // "地址",
    categoryCode: string,              // "站点类型",
    categoryName: string,              // "站点类型名称",
    status: number,              // 1,
    note: string,              // "备注",
    details: IVRMBeDetails[],              // 
    type: string,
    prefix: string,
}

//站点 实体
export interface IVRMBeDetails {
    id: string,                // "911332111d8134f89b45490410550079",
    code: string,                // null,
    orderNum: string,                // 0,
    deleteFlag: string,                // 0,
    createTime: string,                //,
    updateTime: string,                //,
    createUser: string,                // "默认用户",
    updateUser: string,                // null,
    shopCode: string,                // "ETY-M-gSUn-00000019",
    bentityCode: string,                // "实体编码-",
    bentityName: string,                // "实体名称-"
}

//新增
export interface IVRMShopInsert {
    orgCode: string,    // "机构编码",
    orgName: string,    // "机构名称",
    address: string,    // "地址",
    contact: string,    // "联系人",
    branch: string,    // "main",
    phone: string,    // "332",
    name: string,    // "站点名称",
    categoryCode: string,    // "站点类型",
    categoryName: string,    // "站点类型名称",
    note?: string,    // "备注",
    details: {
        shopCode: string,     // "备注",
        bentityCode: string,     // "实体编码",
        bentityName: string,     // "实体名称"
    }[],
    status: number,
    code?: string
}

//编辑
export interface IVRMShopUpdate extends IVRMShopInsert {
    id: string,
}

//搜索条件
export interface IVRMShopSearchFields {
    enable?: string,      // "分支",
    stuats?: string,      // "状态",
    orgCode?: string,      // "机构编码",
    name?: string,      // "站点名称",
    sourceApp?: string,      // "mdm",
    [key: string]: any
}
export interface ICmSearchPageFields {
    page: ISearchPage;
}
export interface IVRMShopSearch
    extends IVRMShopSearchFields, ICmSearchPageFields {
}

//表单字段
export interface IVRMShopFormFields {
    branch: string,
    code?: string,
    name: string,
    orgCode: string,
    orgName: string,
    contact: string,
    phone: string,
    address: string,
    status: boolean,
    categoryCode: string,
    categoryName: string,
    details: string[],
    note?: string,
}

class ShopService {
    async page(searchVo: IVRMShopSearch) {
        const apiUrl = "/zzw-vrm/shop/page";
        return await httpRequest.post<IPage<IVRMShopDetail>>(apiUrl, searchVo);
    }
    async pageFms(searchVo: IVRMShopSearch) {
        const apiUrl = "/fms/no/shop/page";
        return await httpRequest.post<IPage<IVRMShopDetail>>(apiUrl, searchVo);
    }
    async newPageFms(searchVo: any) {
        const apiUrl = "/fms/no/shop/find";
        return await httpRequest.post<IVRMShopDetail[]>(apiUrl, searchVo);
    }
    async pageMd(searchVo: IVRMShopSearch) {
        const apiUrl = "/md/shop/page";
        return await httpRequest.post<IPage<IVRMShopDetail>>(apiUrl, searchVo);
    }
    async one(obj: object) {
        const apiUrl = `/zzw-vrm/shop/one`;
        return await httpRequest.post<IVRMShopDetail>(apiUrl, obj);
    }
    async insert(insertVo: IVRMShopInsert) {
        const apiUrl = "/zzw-vrm/shop/insert";
        return await httpRequest.post<boolean>(apiUrl, insertVo);
    }
    async update(updateVo: IVRMShopUpdate) {
        const apiUrl = "/zzw-vrm/shop/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    //启用禁用
    async disable(params: object) {
        const apiUrl = `/zzw-vrm/shop/change`;
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    async getUser(searchVo: any) {
        const apiUrl = `/zzw-portal/auth/user/findUserDetail`;
        return await httpRequest.post<any>(apiUrl, searchVo);
    }
    async findSupplier(code: string) {
        const apiUrl = `/zzw-vrm/base/supplier/findByUserCode/${code}`;
        return await httpRequest.get<any>(apiUrl);
    }
}

export const shopService = new ShopService();
